import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import AdComponent from './components/AdComponent';
import styles from './App.module.css';
import useCurrentURL from './hooks/useCurrentURL';
import ScrollToTop from './components/ScrollToTop';

// Code-split routes that aren't needed on initial load
const CountryPage = lazy(() => import('./pages/CountryPage'));
const About = lazy(() => import('./pages/About'));
const WhatIsDUNS = lazy(() => import('./pages/WhatIsDUNS'));
const Benefits = lazy(() => import('./pages/Benefits'));
const HowToGet = lazy(() => import('./pages/HowToGet'));
const Articles = lazy(() => import('./pages/Articles'));
const ArticlePage = lazy(() => import('./pages/ArticlePage'));
const DUNSLookup = lazy(() => import('./components/DUNSLookup'));
const CountryList = lazy(() => import('./pages/CountryList'));
const NotFound = lazy(() => import('./pages/NotFound'));

const CanonicalLink = () => {
  const currentURL = useCurrentURL();

  return (
    <Helmet>
      <link rel="canonical" href={currentURL} />
      <meta property="og:url" content={currentURL} />
      <meta name="twitter:url" content={currentURL} />
      <meta property="og:image" content="https://findyourdunsnumber.com/og-image.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content="https://findyourdunsnumber.com/og-image.png" />
    </Helmet>
  );
};

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className={styles.app}>
        <CanonicalLink />
        <Header />
        <main className={styles.mainContent}>
          <Suspense fallback={<div style={{minHeight: '60vh'}} />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/what-is-duns" element={<WhatIsDUNS />} />
              <Route path="/benefits" element={<Benefits />} />
              <Route path="/how-to-get" element={<HowToGet />} />
              <Route path="/country-info/:country" element={<CountryPage />} />
              <Route path="/countries" element={<CountryList />} />
              <Route path="/duns-lookup" element={<DUNSLookup />} />
              <Route path="/all-articles" element={<Articles />} />
              <Route path="/articles/*" element={<ArticlePage />} />
              {/* New static routes must also be added to scripts/routes.js so they get prerendered */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
          <AdComponent position="bottom" adId="7650553099" />
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;